
import { CurrencyApi } from "@/api/CurrencyApi";
import { ExpenseCategoryApi } from "@/api/ExpenseCategoryApi";
import { FormConfigType } from "@/types/dynamicForm";
import { EDITOR_INPUT, SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { generateCurrencyOptionLabel } from "@utils/Currency";
import { CurrencyIdPubSub } from "@utils/pubsubs/PubSub";

const ExpenseFormConfig: FormConfigType = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "checkbox",
                        "name": "excluir_reporte",
                        "label": "Excluir de Reporte",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        }
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "reference_number",
                        "label": "Numero Referencia",
                        "isHorizontal": true,
                        "visibilityHiddenIf": () => true, // by default this input is hidden, suscrption data make it visible
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "currencyId",
                        "label": "Moneda",
                        "optionsFunction": () => CurrencyApi.optionsList({}, (i) => generateCurrencyOptionLabel(i)),
                        "onChangePubSub": (value: string) => CurrencyIdPubSub.publish({ currencyId: value }),
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "date",
                        "name": "fecha",
                        "label": "Fecha",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "expenseCategoryId",
                        "label": "Categoria Gasto",
                        "optionsFunction": () => ExpenseCategoryApi.optionsList(),
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "number",
                        "name": "sequence",
                        "label": "Numero Consecutivo",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 4
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "document_key",
                        "label": "Clave Numerica",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 6
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "identificacion",
                        "label": "Número Cédula",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 4
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "nombre",
                        "label": "Nombre",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 8
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                    },
                ],
                [
                    {
                        "type": "number",
                        "name": "exchange_rate",
                        "label": "Tipo de Cambio",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "subtotal",
                        "label": "Subtotal",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "descuento",
                        "label": "Descuento",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "impuestos",
                        "label": "Impuestos",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "monto",
                        "label": "Total",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": EDITOR_INPUT,
                        "name": "detalle",
                        "label": "Detalle",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                    },
                ],
            ]
        }
    ],
};


export default ExpenseFormConfig;